import {
  Box,
  Button,
  IconButton,
  Stack,
  TextField,
  Typography,
  useTheme,
} from "@mui/material";
import { useFormik } from "formik";
import * as Yup from "yup";
import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useVerifyOtpCodeMutation } from "../../../Store/Slices/rtk";
import { updateCartOnServer } from "../../../Store/Slices/CartSlice/cartSlice";
import { setAuthData } from "../../../Store/Slices/AuthSlice/authSlice";
import { setUserData } from "../../../Store/Slices/userSlice/userSlice";
import TimeRemaining from "./TimeRemaining";
import { useNavigate } from "react-router-dom";
import KeyboardBackspaceIcon from "@mui/icons-material/KeyboardBackspace";
import { notify } from "../../../App";
import { GradientBorderBox } from "../../../Components";

export default function VerifyOTP() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const theme = useTheme();

  const [send, setSend] = useState({ send: false, run: false });
  const { tempToken, phoneNumber } = useSelector((state) => state?.authSlice);
  const cart = useSelector((state) => state?.cartSlice?.list);

  const [verifyOtpCode] = useVerifyOtpCodeMutation();

  const formik = useFormik({
    initialValues: {
      verf_code: "",
    },
    validationSchema: Yup.object({
      verf_code: Yup.string().required("کد احراز هویت الزامی میباشد"),
    }),
    onSubmit: async (values) => {
      try {
        const res = await verifyOtpCode({
          phoneNumber:
            phoneNumber?.[0] === "0" ? phoneNumber : "0" + phoneNumber,
          code: values.verf_code,
          tempToken,
        });
        if (res?.error?.status === 429)
          return notify("درخواست بیش از حد مجاز", "error");

        if (res?.error?.status == 401) return notify("اطلاعات نادرست", "error");

        if (!res?.data?.data?.need_register) {
          dispatch(
            setUserData({
              token: res?.data?.data?.token_data?.token,
              user: res?.data?.data?.token_data?.user,
            })
          );

          if (cart?.length > 0) {
            for (const item of cart) {
              dispatch(
                updateCartOnServer({
                  product_code: item?.code,
                  variant_code: item?.variant_code,
                  qty: item?.quantity,
                })
              );
            }
          }

          notify("احراز هویت با موفقیت انجام شد");
          return navigate("/");
        }

        dispatch(setAuthData({ tempToken: res?.data?.data?.tmp_token }));
        notify("احراز هویت با موفقیت انجام شد");
        navigate("/auth/register");
      } catch (err) {
        console.log(err);
        notify("احراز هویت با خطا مواجه شد", "error");
      }
    },
  });

  return (
    <Stack
      sx={{
        position: "relative",
        width: "100%",
        height: "100vh",
      }}
    >
      {/* main auth box */}
      <Stack
        sx={{
          position: "fixed",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          zIndex: 1000,
          height: { xs: "300px", md: "400px", xl: "505px" },
          backgroundImage: 'url("/media/Layout/AuthLayout/OTP/group.svg")',
          backgroundSize: "contain",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
          padding: "30px",
          width: "100%",
          maxWidth: { xs: "270px", sm: "350px", md: "600px", xl: "800px" },
        }}
      >
        {/* Back Button */}
        <IconButton
          onClick={() => navigate(-1)}
          sx={{
            position: "absolute",
            top: { xs: "10px", sm: "15px" },
            left: { xs: "10px", sm: "15px" },
            color: theme.palette.primary.main,
            zIndex: 2001,
          }}
        >
          <KeyboardBackspaceIcon />
        </IconButton>

        {/* Form */}
        <Stack
          component="form"
          onSubmit={formik.handleSubmit}
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            position: "relative",
            gap: "20px",
            width: { xs: "80%", sm: "50%", md: "50%", lg: "50%" },
            mt: { xs: "0px", sm: "0px", md: "50px", xl: "80px" },
            mx: "auto",
          }}
        >
          <Typography
            sx={{
              fontSize: { lg: "24px", sm: "18px", xs: "15px" },
              mt: { lg: "15px", md: "15px", xs: "10px" },
              textAlign: "center",
              fontWeight: "bold",
            }}
          >
            ورود
          </Typography>

          <Typography
            sx={{
              fontSize: { lg: "15px", md: "12px", xs: "12px" },
              textAlign: "center",
              my: "8px",
            }}
          >
            کد ارسال‌شده به {phoneNumber}
          </Typography>

          <TextField
            variant="outlined"
            fullWidth
            sx={{
              "& .MuiOutlinedInput-root": {
                padding: 0,
                bgcolor: theme.palette.background.paper,
                border: "1px solid gray",
              },
              "& .MuiOutlinedInput-input": {
                padding: "8px",
                textAlign: "left",
              },
              "& .MuiInputBase-input::placeholder": {
                // color: theme.palette.warning.main,
                opacity: 1,
              },

              // borderRadius: "12px",
              // height: "37px",
              mb: { lg: "20px", md: "15px", xs: "0px" },
            }}
            name="verf_code"
            value={formik.values.verf_code}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            error={formik.touched.verf_code && Boolean(formik.errors.verf_code)}
            helperText={formik.touched.verf_code && formik.errors.verf_code}
          />

          <TimeRemaining send={send} setSend={setSend} />

          <Button type="submit" variant="contained" sx={{ width: "100%" }}>
            ورود
          </Button>
        </Stack>
        <GradientBorderBox />
      </Stack>
    </Stack>
  );
}
